import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Mail = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 6H5C3.35 6 2 7.35 2 9V23C2 24.65 3.35 26 5 26H27C28.65 26 30 24.65 30 23V9C30 7.35 28.65 6 27 6ZM26.613 8L17.425 17.413C17.05 17.788 16.55 18 16.012 18C15.474 18 14.975 17.788 14.612 17.425L5.387 8H26.612H26.613ZM27 24H5C4.45 24 4 23.55 4 23V9.437L13.175 18.824C13.925 19.574 14.937 19.999 16 19.999C17.063 19.999 18.075 19.586 18.837 18.824L28 9.437V23C28 23.55 27.55 24 27 24Z" />
	</svg>
);

export default Mail;
